import ActionTypes from '../../../../../constants/ActionTypes';
import { INumberOfDevices, ISetAditionalDevicesPopupVisibilityActions } from './types';

export function setAdditionalDevicesPopupVisibilityAction(visibility: boolean): ISetAditionalDevicesPopupVisibilityActions {
  return {
    type: ActionTypes.MANHATTAN.FTTH.ADDITIONAL_DEVICES.SET_VISIBILITY,
    payload: visibility,
  };
}

export function setStbNumberAction(numberOfDevices: INumberOfDevices) {
  return {
    type: ActionTypes.MANHATTAN.FTTH.ADDITIONAL_DEVICES.SET_STB_NUMBER,
    payload: numberOfDevices
  };
}

export function setSelectedStbNumberAction(numberOfDevices: INumberOfDevices) {
  return {
    type: ActionTypes.MANHATTAN.FTTH.ADDITIONAL_DEVICES.SET_SELECTED_STB_NUMBER,
    payload: numberOfDevices
  };
}
